module.exports = __webpack_public_path__ + "img/object_utilyn.040765ce.svg";